import { Coordinator } from 'modules/domain/user/types'
import { Logistician } from '../types'
import { ProductLogistic } from 'modules/domain/logisticsKR/types'

export enum RatesTabTypes {
  cereals = 'cereals',
  oilseeds = 'oilseeds',
  average = 'average',
  cerealsRails = 'cerealsRails',
  oilseedsRails = 'oilseedsRails',
}

export enum RatesProductTypes {
  cereals = 'cereals',
  oilseeds = 'oilseeds',
}

export const tabProductMap = {
  [RatesTabTypes.cereals]: RatesProductTypes.cereals,
  [RatesTabTypes.oilseeds]: RatesProductTypes.oilseeds,
  [RatesTabTypes.average]: null,
  [RatesTabTypes.cerealsRails]: RatesProductTypes.cereals,
  [RatesTabTypes.oilseedsRails]: RatesProductTypes.oilseeds,
}

export type RailwayStation = {
  id: number
  title: string
  station_code: string
  railway_region: string
}

export enum RailCarType {
  boxcar = 'boxcar',
  container_flatcar = 'container_flatcar',
  gondola_car = 'gondola_car',
  hopper_car = 'hopper_car',
  tank_car = 'tank_car',
}

export type RailwayRoute = {
  id: number
  from_station: RailwayStation
  to_station: RailwayStation
  product_type: RatesProductTypes
  modified: string
  rate: number
  comment: string
  product?: ProductLogistic
  rail_car_owner?: { id: number; name: string }
  rail_car_type?: RailCarType
  start_date: string
  end_date: string
  rail_car_load_limit?: number
  created_by: Coordinator
  history_info?: {
    rate?: number
    modified: string
    modified_by?: Coordinator
  }
}

export type RailwayRouteDTO = {
  from_station: number
  to_station: number
  product_type: RatesProductTypes
  rate: number
  comment: string
  product: string | null
  rail_car_owner: string | null
  rail_car_type: RailCarType | ''
  start_date: string | null
  end_date: string | null
  rail_car_load_limit: number | null
}

export interface RangeType {
  upper: number
  lower: number
}

export interface RateType {
  id?: string
  rate?: number
  rate_with_overload?: number
  distance_range: RangeType
  history_info?: {
    rate?: number
    rate_with_overload?: number
    modified: string
    modified_by?: Coordinator
  }
}

export interface RateDTO {
  id: string
  logistics_rates: RateType[]
  name: string
  responsible_logisticians: Logistician[]
}

export interface EditableRatesDTO {
  sale_regions: string | string[]
  rates: RateType[]
  product_type?: RatesTabTypes | string
  responsible_logisticians: string[]
}

export type EditableAverageRatesDTO = Pick<EditableRatesDTO, 'rates'>
